import React from "react";
import "./Greeting.css";
// import SocialMedia from "../../components/socialMedia/SocialMedia";
import Button from "../../components/button/Button";
import { greeting } from "../../portfolio";
import { Fade } from "react-reveal";
import BannerImg from "./BannerImg";
import Typewriter from "typewriter-effect";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import { competitiveSites } from "../../portfolio";
export default function Greeting(props) {
  const theme = props.theme;
  return (
    <Fade bottom duration={2000} distance="40px">
      <div className="greet-main" id="greeting">
        <div className="greeting-main">
          <div className="greeting-text-div">
            <div>
              <h1 className="greeting-text" style={{ color: theme.orange}}>
                {greeting.title}
              </h1>
              <h1 className="greeting-sub" style={{ color: theme.grayText }}>
                I'm <mark data-entity="person">{greeting.sub}</mark>
              </h1>
              <h1
                className="greeting-typewriter"
                style={{ fontSize: 59, color: theme.blue }}
              >
                <Typewriter
                  onInit={(typewriter) => {
                    typewriter
                      .typeString("Frontend Developer(ReactJS)")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Backend Developer(NodeJS)")
                      .pauseFor(200)
                      .deleteAll()
                      .typeString("Full stack Developer(MERN)")
                      .pauseFor(200)
                      // .deleteAll()
                      // .typeString("IT Engineer")
                      // .pauseFor(200)
                      .start();
                  }}
                  options={{
                    autoStart: true,
                    loop: true,
                  }}
                />
              </h1>
              <span
                className="greeting-text-span subTitle"
                style={{ color: theme.text }}
              >
                {/* <div className="entities">
                  A <mark data-entity="noun">full stack web developer</mark> who{" "}
                  <mark data-entity="skill">develops softwares </mark>to{" "}
                  <mark data-entity="verb">solve peoples'problem</mark>
                  with his entrepreneurial mindset and design skill.
                </div> */}
                <div className="entities">
                  A <mark data-entity="noun">full stack web developer</mark> who{" "}
                  <mark data-entity="skill">writes clean codes</mark>to{" "}
                  <mark data-entity="verb">develop softwares</mark>
                  with smooth performance and highest security.
                </div>
              </span>
              <CompetitiveSites logos={competitiveSites.competitiveSites} />
              <div className="button-greeting-div">
                <Button text="Contact me" href="/contact" />
                <Button
                  text="See my resume"
                  newTab={true}
                  href={greeting.resumeLink}
                />
              </div>
            </div>
          </div>
          <div className="greeting-image-div">
            <BannerImg />
          </div>
        </div>
      </div>
    </Fade>
  );
}
